import { API_TYPES } from '@/main/app.constants';

export const PATH_SEPARATOR = '»';

export const IGNORED_ITEM_TYPES = [API_TYPES.THRESHOLD_METRIC, API_TYPES.DISPLAY];
